import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '../components/common/login/login.component';
import { CommonLayoutComponent } from '../components/common/common-layout/common-layout.component';
// import { authGuard } from './auth.guard';
import { logGuardGuard } from '../guards/log-guard.guard';
import { ForgetPasswordComponent } from '../components/common/forget-password/forget-password.component';
import { OtpComponent } from '../components/common/otp/otp.component';
import { authGuard } from '../guards/auth.guard';
import { childGuard } from '../guards/child.guard';
import { UnAuthorisedComponent } from '../components/un-authorised/un-authorised.component';
import { PageNotFoundComponent } from '../components/page-not-found.component';
import { SharedModule } from '../components/shared/shared.module';
import { SupplierQuestionerComponent } from '../components/supervisor/supplier-assessment-suit/supplier-questioner/supplier-questioner.component';
import { UnsavedChangesGuard } from '../guards/unsaved-changes.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [logGuardGuard],
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'forgetpassword',
    component: ForgetPasswordComponent,
  },
  {
    path: 'VerifyOtp',
    component: OtpComponent,
  },
  {
    path: 'Unauthorised-page',
    component: UnAuthorisedComponent,
  },
  {
    path: '',
    component: CommonLayoutComponent,
    data: { role: ['SuperAdmin', 'Admin'] },
    loadChildren: () =>
      import('../components/organizationAdmin/organization.module').then(
        m => m.OrganizationModule
      ),
    // canActivate: [authGuard],
    // canActivateChild: [logGuardGuard],
    // canActivateChild: [authGuard],
  },
  {
    path: '',
    component: CommonLayoutComponent,
    data: { role: ['Manager', 'Operator', 'Supervisor'] },
    loadChildren: () =>
      import('../components/supervisor/supervisor.module').then(
        m => m.SupervisorModule
      ),
    // canActivate: [authGuard],
    // canActivateChild: [authGuard],
  },
  {
    path: 'supplier-questioner/:id',
    component: SupplierQuestionerComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
    SharedModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
